import React from 'react'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { addToast } from '@mobi/component-library/Feedback/Toast'
import { navChange } from '@classic/Foundation/Navigation/Nav'
import { useObservableImmutable } from '@core/Utils/hooks'
import { hideLogin, refreshLogonState } from '@core/Areas/Login/helpers'
import { ChangePasswordViewObserve } from './ChangePassword'
import { Reset, state$, UpdateCurrentPassword } from './driver'
import { CHANGE_TEMP_PASSWORD_ROUTE } from './constants'
import { setIsBiometricsEnabledOnTempPasswordChange } from '../Login/Store'
import { getIsBiometricsEnabledOnTempPasswordChange } from '../Login/Store/selectors'

export const navigateToChangeTempPassword = ({
  accountNumber,
  password,
}: NavigateToChangeTempPassword) => {
  UpdateCurrentPassword(password)
  navChange(`/${CHANGE_TEMP_PASSWORD_ROUTE}/${accountNumber}`)
  hideLogin()
}

export const ChangeTemporaryPassword = () => {
  const dispatch = useDispatch()
  const { accountNumber } = useParams<{ accountNumber?: string }>()
  const { isChangeTemporaryPasswordSuccess } = useObservableImmutable(state$, [
    'isChangeTemporaryPasswordSuccess',
  ])
  const isBiometricsEnabledOnTempPasswordChange = useSelector(
    getIsBiometricsEnabledOnTempPasswordChange
  )

  React.useEffect(() => Reset, [])

  React.useEffect(() => {
    if (!accountNumber) navChange('/')
  }, [accountNumber])

  React.useEffect(() => {
    if (isChangeTemporaryPasswordSuccess) {
      refreshLogonState()
      navChange('/')
      addToast({ id: 'change-password', title: 'Password Changed', icon: 'success' })
      if (isBiometricsEnabledOnTempPasswordChange)
        dispatch(setIsBiometricsEnabledOnTempPasswordChange(false))
    }
  }, [dispatch, isChangeTemporaryPasswordSuccess, isBiometricsEnabledOnTempPasswordChange])

  if (!accountNumber) {
    return null
  }

  return (
    <ChangePasswordViewObserve
      accountNumber={accountNumber}
      isChangeTemporaryPassword
      isDesktop={false}
    />
  )
}

// Types
interface NavigateToChangeTempPassword {
  accountNumber: string
  password: string
  isTogglingBiometricsOn?: boolean
}
